import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Portfolio from '@/components/Portfolio';
import SmoothScroll from '@/components/SmoothScroll';
import Preloader from '@/components/Preloader';
import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import ScrollAmbient from '@/components/ScrollAmbient';
import Packages from '@/components/Packages';
import Reels from '@/components/Reels';
import WeddingFilms from '@/components/WeddingFilms';
import About from '@/components/About';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import { ContactModalProvider } from '@/components/ContactModalContext';

function Landing() {
  const [ready, setReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (ready && target) {
      const t = setTimeout(() => {
        const el = document.getElementById(target);
        if (!el) return;
        if (window.lenis) {
          window.lenis.scrollTo(el, { offset: -70, duration: 1.1 });
        } else {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
      return () => clearTimeout(t);
    }
  }, [ready, location.state]);

  return (
    <>
      <Preloader onDone={() => setReady(true)} />
      <ContactModalProvider>
        <SmoothScroll>
          <ScrollAmbient />
          <main className="relative z-10 text-white">
            <Navigation />
            <Hero />
            <Packages />
            <Reels />
            <WeddingFilms />
            <About />
            <Contact />
            <Footer />
          </main>
        </SmoothScroll>
      </ContactModalProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0a0a0a',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 0,
            fontFamily: 'Manrope, sans-serif',
          },
        }}
      />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
